import { useTranslation } from 'next-i18next'
import { FC, useContext } from 'react'
import { match } from 'ts-pattern'
import VisibilityLogo from 'assets/icons/visibility.svg'
import { LocaleContext } from 'components/common/LocaleContext'
import { displayDate } from 'components/common/date.utils'
import {
  PreviewTitle,
  PreviewTopBar,
  StyledGroupsLogo
} from 'components/pages/step.style'
import { LightGroup } from 'domain/models/Group/EntityGroup'
import { getGroupRegistrationStatus } from 'live/Group/convertPrismaGroupToLiveReduction'

interface GroupTopBarProps {
  group: LightGroup
}

interface PreviewTopBarProps {
  raceName: string | undefined
}
export const GroupTopBarBanner = ({ group }: GroupTopBarProps) => {
  const { t } = useTranslation('checkout')
  const { dateStringLocale } = useContext(LocaleContext)
  const groupWithStatus = {
    ...group,
    groupRegistrationStatus: getGroupRegistrationStatus(group)
  } as const

  return (
    <PreviewTopBar $backgroundColor={group.isActive ? 'green' : 'warning'}>
      <StyledGroupsLogo />
      <PreviewTitle>
        {match(groupWithStatus)
          .with({ isActive: false }, () =>
            t('preview.groupBar.inactive', { groupName: group.name })
          )
          .with({ groupRegistrationStatus: 'early' }, () =>
            t('preview.groupBar.early', {
              groupName: group.name,
              date:
                group.registrationOpeningDate &&
                displayDate(group.registrationOpeningDate, dateStringLocale)
            })
          )
          .otherwise(({ groupRegistrationStatus }) =>
            t(`preview.groupBar.${groupRegistrationStatus}`, {
              groupName: group.name
            })
          )}
      </PreviewTitle>
    </PreviewTopBar>
  )
}

export const PreviewTopBarBanner: FC<PreviewTopBarProps> = ({ raceName }) => {
  const { t } = useTranslation('checkout')

  return (
    <PreviewTopBar>
      <VisibilityLogo />
      <PreviewTitle>{t('preview.topbar', { raceName })}</PreviewTitle>
    </PreviewTopBar>
  )
}
